import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TextAndImagesList.css';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import AudioContentModal from './Modals/AudioContentModal';

function AudioContentList({ curriculum, setCurriculum, clCardItem, setClCardItem, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CITLST NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CITLST_A1">
          <FontAwesomeIcon icon={faVolumeUp} />
        </div>
        <div className="CITLST_A2">
          Audio
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <AudioContentModal curriculum={curriculum} setCurriculum={setCurriculum} clCardItem={clCardItem} setClCardItem={setClCardItem} lessonParent={lessonParent} isUploadingViaApi={isUploadingViaApi} setIsUploadingViaApi={setIsUploadingViaApi} />
      </Modal>
    </div>
  );
}

export default AudioContentList;
